var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalCreate',{ref:"modalCreate",attrs:{"product-id":_vm.packageId,"submitting":_vm.submitting},on:{"submit":_vm.doStorePackageItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }